// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-recommendation-index-tsx": () => import("./../../../src/pages/recommendation/index.tsx" /* webpackChunkName: "component---src-pages-recommendation-index-tsx" */),
  "component---src-templates-assessment-index-tsx": () => import("./../../../src/templates/assessment/index.tsx" /* webpackChunkName: "component---src-templates-assessment-index-tsx" */)
}

